import type { SubscriptionFrequency, SubscriptionPreferredWeekday } from '@/lib/api/api.gen'

export const subscriptionFrequencyOptions: { id: SubscriptionFrequency; name: string }[] = [
  { id: 'weekly', name: 'Weekly' },
  { id: 'biweekly', name: 'Biweekly' },
  { id: 'monthly', name: 'Monthly' },
  { id: 'every_3_months', name: 'Every 3 months' },
  { id: 'every_6_months', name: 'Every 6 months' },
  { id: 'yearly', name: 'Annually' },
]

export const defaultSubscriptionFrequencyOptions = subscriptionFrequencyOptions.map(
  (option) => option.id
)

export const subscriptionPreferredWeekdayOptions: {
  id: SubscriptionPreferredWeekday
  name: string
}[] = [
  { id: 'sunday', name: 'Sunday' },
  { id: 'monday', name: 'Monday' },
  { id: 'tuesday', name: 'Tuesday' },
  { id: 'wednesday', name: 'Wednesday' },
  { id: 'thursday', name: 'Thursday' },
  { id: 'friday', name: 'Friday' },
  { id: 'saturday', name: 'Saturday' },
]

export function subscriptionFrequencySupportsPreferredWeekday(
  frequency: string | null | undefined
): boolean {
  return ['monthly', 'every_3_months', 'every_6_months', 'yearly'].includes(String(frequency || ''))
}

/** The weekday of a `Y-m-d` date, or `''` when it isn't one. */
export function preferredWeekdayFromDate(
  dateYmd: string | null | undefined
): SubscriptionPreferredWeekday | '' {
  const match = String(dateYmd || '').match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) {
    return ''
  }

  const [, year, month, day] = match
  const weekdayIndex = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))).getUTCDay()

  return subscriptionPreferredWeekdayOptions[weekdayIndex]?.id ?? ''
}
